


























































import { Component, Vue } from 'vue-property-decorator';
import { curCoreClient, CoreClient, DeviceImage } from '@/services/CoreClient';
import SectionHeader from '@/components/SectionHeader.vue';

@Component({
  components: { SectionHeader },
})
export default class DeviceImages extends Vue {

  imageList: DeviceImage[] = [];
  loading = false;
  errorMsg = '';
  deletingId = '';
  lightboxUrl = '';
  uploading = false;

  private coreClient: CoreClient = curCoreClient;

  get deviceId(): string {
    return this.$route.params.deviceId;
  }

  get headerIconList(): object[] {
    return [
      { name: 'arrow-left', title: 'back to device', event: 'back' },
      { name: 'upload', title: 'upload image', event: 'upload-image', disabled: this.uploading },
    ];
  }

  async mounted() {
    await this.loadImages();
  }

  async loadImages() {
    this.loading = true;
    this.errorMsg = '';

    const reply = await this.coreClient.getDeviceImages({ deviceId: this.deviceId });

    this.loading = false;

    if (reply.httpCode === 403)
      return this.$router.push({ name: 'login' });

    if (reply.errorMsg)
      return this.errorMsg = `Unable to load images: ${reply.errorMsg}`;

    this.imageList = reply.imageList || [];
  }

  goBack() {
    this.$router.push({ name: 'device', params: { deviceId: this.deviceId } });
  }

  triggerUpload() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    input.value = '';

    this.uploading = true;
    this.errorMsg = '';

    const reply = await this.coreClient.uploadDeviceImage({ deviceId: this.deviceId, file });

    this.uploading = false;

    if (reply.httpCode === 403)
      return this.$router.push({ name: 'login' });

    if (reply.errorMsg)
      return this.errorMsg = `Upload failed: ${reply.errorMsg}`;

    await this.loadImages();
  }

  async deleteImage(imageId: string) {
    this.deletingId = imageId;
    this.errorMsg = '';

    const reply = await this.coreClient.deleteDeviceImage({ deviceId: this.deviceId, imageId });

    this.deletingId = '';

    if (reply.httpCode === 403)
      return this.$router.push({ name: 'login' });

    if (reply.errorMsg)
      return this.errorMsg = `Delete failed: ${reply.errorMsg}`;

    this.imageList = this.imageList.filter(img => img.imageId !== imageId);
  }

  openLightbox(url: string) {
    this.lightboxUrl = url;
  }
}
